<section [formGroup]="form" #content>
  @if (account) {
    <mat-form-field appearance="outline">
      <mat-label translate="account-setup-primary-use"></mat-label>
      <mat-select
        formControlName="useType"
        (selectionChange)="updateUseType($event)"
        [placeholder]="'account-setup_select_one_placeholder' | translate"
        disableOptionCentering
        panelClass="offsetPanel"
        required>
        @for (group of groupedUseTypes; track group) {
          <mat-optgroup [label]="group.name">
            @for (type of group.types; track type.use_type_id) {
              <mat-option
                [value]="type">
                {{ type.name }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.useType.hasError('required')) {
        <mat-error
          translate="account-setup-error-required-primary-use">
        </mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field appearance="outline" class="half">
    <mat-label translate="sign-up-form-label-first-name"></mat-label>
    <input matInput formControlName="firstName" maxlength="255" (blur)="updateSelf()" required/>
    @if (form.controls.firstName.hasError('required') || form.controls.firstName.hasError('whitespace')) {
      <mat-error
        translate="sign-up-form-validation-first-name-required">
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="half">
    <mat-label translate="sign-up-form-label-last_name"></mat-label>
    <input matInput formControlName="lastName" maxlength="255" (blur)="updateSelf()" required/>

    @if (form.controls.lastName.hasError('required') || form.controls.lastName.hasError('whitespace')) {
      <mat-error
        translate="sign-up-form-validation-last-name-required">
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label translate="common_email"></mat-label>
    <input matInput formControlName="email" maxlength="100" (blur)="updateSelf()" class="fullstory-ignore" required/>
    @if (form.controls.email.hasError('required')) {
      <mat-error
        translate="sign-up-form-validation-email-required">
      </mat-error>
    }
    @if (form.controls.email.hasError('duplicate')) {
      <mat-error
        class="duplicate-email"
        translate="account-editor_duplicate-email">
      </mat-error>
    }
    @if (form.controls.email.hasError('support')) {
      <mat-error
        class="support-required"
        translate="account-editor_email-support-required"
        [translateParams]="translationParams">
      </mat-error>
    }
    @if (form.controls.email.hasError('unknown')) {
      <mat-error
        class="unknown"
        translate="common_unknown-error">
      </mat-error>
    }
  </mat-form-field>

  @if (account) {
    <mat-form-field appearance="outline" [class.half]="showVideoPhone$ | async">
      <mat-label translate="sign-up-form-label-phone-number"></mat-label>
      <input matInput formControlName="phoneNumber" maxlength="25" (blur)="updateSelf()" class="fullstory-ignore" />
    </mat-form-field>
  }

  @if (account && (showVideoPhone$ | async)) {
    <mat-form-field appearance="outline" class="half">
      <mat-label translate="sign-up-form-label-video-phone-number"></mat-label>
      <input matInput formControlName="videoPhoneNumber" maxlength="25" (blur)="updateSelf()" class="fullstory-ignore" />
    </mat-form-field>
  }
</section>

<span
  class="terms-and-privacy"
	[innerHtml]="'terms-privacy-with-links-signup' | translate : {
		terms: 'https://get.goreact.com/terms',
		privacy: 'https://get.goreact.com/privacy'
	}">
</span>
